export const ConcessionSchemeInstallmentHeader = [
  'Concession Name',
  'Concession Type',
  'Applicable on',
  'type',
  'Percentage',
  'Delete'
];

export const OptionalConcessionParticularOptions = [
  { label: 'Tuition Fee', value: 'Tuition Fee' },
  { label: 'Term Fee', value: 'Term Fee' },
  { label: 'Admission Fee', value: 'Admission Fee' },
  { label: 'Security Deposit', value: 'Security Deposit' },
  { label: 'Registration Fee', value: 'Registration Fee' },
  { label: 'Activity Fee', value: 'Activity Fee' },
  { label: 'Imprest', value: 'Imprest' },
  { label: 'Indian Board', value: 'Indian Board' },
  { label: 'International Board', value: 'International Board' },
  { label: 'Laboratory Fee', value: 'Laboratory Fee' },
  { label: 'Part A', value: 'Part A' },
  { label: 'Part B', value: 'Part B' }
];
export const ConcessionTypeOptions = [
  {
    label: 'Dependent',
    value: 'DEPENDENT'
  },
  {
    label: 'Independent',
    value: 'INDEPENDENT'
  }
];

export const ConcessionAmountTypeOptions = [
  {
    label: 'Percentage',
    value: 'percentage'
  },
  {
    label: 'Amount',
    value: 'amount'
  }
];
